@if (!!contactField) {
  <div class="mb-20">
    <div class="address-labels">
      <label>{{ "type_of_address" | translate }}</label>
      <label>{{ "address" | translate }}</label>
    </div>
    <div class="container-left-right">
      <div class="flex-grow mr-0">
        <bp-input
          [type]="'text'"
          [(value)]="contactField.value"
          [formGroupClass]="false"
          [error]="validationError | translate"
          [placeholder]="'enter_an_address' | translate"
          [readonly]="!contactField.isEditable()"
          (onKeyEnter)="saveEmit.emit()">
          <bp-select
            class="contact-edit-select mr-10 full-border"
            [options]="coinOptions$ | async"
            [(selectedValue)]="contactField._type"
            (selectedValueChange)="onContactDropdownChange($event)"
            (searchOutput)="searchListUpdate($event)"
            [searchTermOnClose]="getCurrentCoinName()"
            [searchable]="true"
            [customSearchFn]="getCustomSearch()"
            (scrollToEnd)="fetchListUpdate()"
            [isLoading]="getLoadingState$() | async"
            [bindLabel]="'name'"
            left>
          </bp-select>
        </bp-input>
        <!-- DESTINATION TAG / STELLAR MEMO -->
        @if (currentCoin?.supportsTag()) {
          <div class="mt-5">
            <bp-input
              [type]="'text'"
              [(value)]="contactField.destination_tag"
              [formGroupClass]="false"
              [error]="validationError | translate"
              [placeholder]="getPlaceholderName() | translate"
              [readonly]="!contactField.isEditable()"
              (onKeyEnter)="saveEmit.emit()">
              @if (isStellar()) {
                <bp-select
                  class="contact-edit-select"
                  [(selectedValue)]="contactField._dt_type"
                  [options]="getDtTypes"
                left></bp-select>
              }
            </bp-input>
          </div>
        }
      </div>
      <div class="flex-no-shrink remove w-20">
        <a class="font-size-20" (click)="deleteEmit.emit()" [tabIndex]="0">
          <span class="bpi__icon-minus-round"></span>
        </a>
      </div>
    </div>
  </div>
  <div class="mb-20">
    <label>{{ "custom_title_optional" | translate }}</label>
    <div class="container-left-right">
      <div class="flex-grow">
        <bp-input
          [type]="'text'"
          [maxlength]="40"
          [(value)]="contactField.name"
          [formGroupClass]="false"
          [placeholder]="'label_for_contact_address_title' | translate"
          (onKeyEnter)="saveEmit.emit()">
        </bp-input>
      </div>
    </div>
  </div>
}
